import React, { useState } from "react";
import { Input } from '@material-ui/core';
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';
import InputMask from 'react-input-mask';


function StringBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    mascara,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
    const classes = S.useStyles();
    const [cpfCnpjCheck, setCpfCnpjCheck] = useState(false);

    const maskCreation = () => {
        switch (mascara){
            case 'CNPJCPF':
                let stringReplaced = valoresRespostas[ordem].replace(/\D/g,'');
                if(stringReplaced.length > 11 || cpfCnpjCheck) {
                    return '99.999.999/9999-99'  
                } else {
                    return '999.999.999-99';
                }
            case 'CPF':
                return '999.999.999-99'
            case 'CNPJ':
                return '99.999.999/9999-99'
            case 'CEP':
                return '99999-999'
            case 'TELEFONE':
                return '99999-9999'
            default:
                return mascara ? mascara : ''
        }
    }

    return (
        <>
            <label className={classes.label}>{title}</label>
            <Paper className={classes.medium} style={{ width: `${componenteWidth}px` }} elevation={0}>
                {mascara === '' ? (
                <>
                    <Input
                        style={{ textTransform: 'uppercase !important', paddingLeft: '10px' }}
                        type='text'
                        name={filterName}
                        className={classes.input}
                        onChange={(e) => {
                            handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                        }}
                    />
                </>
                ) : (
                    <>
                    <InputMask
                    mask={maskCreation()}
                    name={filterName}
                    //value={valoresRespostas[ordem]}
                    disabled={isLoading || disabledList[ordem]}
                    onChange={(e) => {
                        let currentValue = e.target.value.replace(/\D/g,'');
                        if(mascara === 'CNPJCPF') {
                            let savedValue = valoresRespostas[ordem].replace(/\D/g,'');
                            if (savedValue.length === currentValue.length && savedValue.length > 0) {
                                setCpfCnpjCheck(true)
                            } else {
                                setCpfCnpjCheck(false)
                            }
                        }
                        handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                    }}
                    autocomplete="false"
                >
                    {(props) => (
                    <Input
                        {...props}
                        style={{ textTransform: 'uppercase !important', paddingLeft: '10px' }}
                        type='text'
                        name={filterName}
                        className={classes.input}
                    />
                    )}
                </InputMask>
                    </>
                )}
            </Paper>
        </>
    );
}

export default StringBox;
